function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedStartDateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Start date icon",
    d: "M11.333 6.693A4.654 4.654 0 1 0 16 11.333a4.672 4.672 0 0 0-4.667-4.64zm0 7.974a3.32 3.32 0 1 1 3.333-3.333 3.324 3.324 0 0 1-3.333 3.333zm1.138-3.138a.667.667 0 1 1-.943.943l-.667-.667a.666.666 0 0 1-.2-.471V10A.667.667 0 1 1 12 10v1.057zM16 4.667V6a.667.667 0 1 1-1.333 0V4.667a2 2 0 0 0-2-2H3.333a2 2 0 0 0-2 2v.667h6a.667.667 0 0 1 0 1.333h-6v6a2 2 0 0 0 2 2H6A.667.667 0 1 1 6 16H3.333A3.337 3.337 0 0 1 0 12.667v-8a3.337 3.337 0 0 1 3.333-3.334H4V.667a.667.667 0 0 1 1.333 0v.667h5.333V.667a.667.667 0 1 1 1.334 0v.667h.667A3.337 3.337 0 0 1 16 4.667z",
    style: {
      fill: "#0F1177"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedStartDateIcon);
export default __webpack_public_path__ + "static/media/detailed-start-date-icon.416ca8ff679d4bfaacd7cba5c483588f.svg";
export { ForwardRef as ReactComponent };